import { getAPIConfig } from '../../../../../../../utils';
import { getProductListToPath } from '../../../../../browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';

const getItemQuantity = (
  isCanceledList,
  quantityCanceled,
  isNonEcom,
  quantity,
  quantityReturned = 0
) => {
  if (isCanceledList) {
    return quantityCanceled;
  }
  if (isNonEcom && quantity > quantityReturned) {
    return quantity - quantityReturned;
  }
  return quantity;
};

const getSeoUrl = (seotoken) => {
  const { siteId } = getAPIConfig();
  return `/${siteId}/p/${seotoken}`;
};

export const getPdpAsPathurl = (
  isProductBrandOfSameDomain,
  crossDomain,
  brandSpecificCrossDomain,
  brand,
  seoToken,
  pdpUrl,
  isCrossBrandMerchandisingEnabled
) => {
  let pdpLinkPath = pdpUrl;
  if (seoToken) {
    pdpLinkPath = getSeoUrl(seoToken);
  }
  if (isProductBrandOfSameDomain) {
    return pdpLinkPath;
  }
  if (isCrossBrandMerchandisingEnabled) return `${pdpLinkPath}$brand=${brand.toUpperCase()}`;

  return `${brandSpecificCrossDomain[brand.toUpperCase()]}${pdpLinkPath}`;
};

export const getPdpToPath = (
  isProductBrandOfSameDomain,
  crossDomain,
  brandSpecificCrossDomain,
  brand,
  seoToken,
  pdpUrl,
  isCrossBrandMerchandisingEnabled
) => {
  let pdpLinkPath = pdpUrl;
  if (seoToken) {
    pdpLinkPath = getSeoUrl(seoToken);
  }

  if (isProductBrandOfSameDomain) return getProductListToPath(pdpLinkPath);
  if (isCrossBrandMerchandisingEnabled)
    return `${getProductListToPath(pdpLinkPath)}$brand=${brand.toUpperCase()}`;
  return `${brandSpecificCrossDomain[brand.toUpperCase()]}${pdpLinkPath}`;
};

export default getItemQuantity;
